/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from '../server/defs.defs.js'

const $nsid = 'com.atproto.admin.getInviteCodes'

export { $nsid }

/** Get an admin view of invite codes. */
const main = l.query(
  $nsid,
  l.params({
    sort: l.optional(
      l.withDefault(l.string<{ knownValues: ['recent', 'usage'] }>(), 'recent'),
    ),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 500 }), 100),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    codes: l.array(
      l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
